
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"-16392.549 22443.451 14.011 11.1"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Symbol_236_2","data-name":"Symbol 236 – 2","transform":"translate(-17311 21837)"}},[_c('path',{staticClass:"cls-1",attrs:{"id":"Path_3729","d":"M3 3.4l4.853 4.765a2.031 2.031 0 0 0 2.735 0l4.794-4.706","data-name":"Path 3729","transform":"translate(916.265 603.983)"}}),_c('path',{staticClass:"cls-1",attrs:{"id":"Line_2030","d":"M3.941 5.324L0 0","data-name":"Line 2030","transform":"translate(927.706 611.295)"}}),_c('path',{staticClass:"cls-1",attrs:{"id":"Line_2031","d":"M0 5.324L4.029 0","data-name":"Line 2031","transform":"translate(919.236 611.295)"}}),_c('path',{staticClass:"cls-1",attrs:{"id":"Path_3731","d":"M14.159 12.1H2.953a.854.854 0 0 1-.853-.853V2.953a.854.854 0 0 1 .853-.853h11.206a.854.854 0 0 1 .853.853v8.294a.854.854 0 0 1-.853.853z","data-name":"Path 3731","transform":"translate(916.9 604.9)"}})])])
          )
        }
      }
    